import { z } from "zod";
import { PostalAddressSchema } from "./PostalAddress";
import { ExamTypeEnum } from "./ExamType";

export const examLocationWeekdays = {
  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  saturday: "Samstag",
};

const ExamLocationWeekdaysEnum = z.enum(Object.keys(examLocationWeekdays) as [keyof typeof examLocationWeekdays]);
export type ExamLocationWeekday = z.infer<typeof ExamLocationWeekdaysEnum>;

export const ExamLocationSchema = z.object({
  uid: z.string().nonempty(),
  name: z.string(),
  postalAddress: PostalAddressSchema,
  types: z.array(ExamTypeEnum),
  theoryExamDaysInAdvance: z.optional(z.number().int().positive()),
  practicalExamDaysInAdvance: z.optional(z.number().int().positive()),
  theoryExamWeekdays: z.optional(z.array(ExamLocationWeekdaysEnum)),
  practicalExamWeekdays: z.optional(z.array(ExamLocationWeekdaysEnum)),
  deleted: z.optional(z.boolean()).transform((val) => !!val),
});
export type ExamLocation = Omit<z.infer<typeof ExamLocationSchema> & { id: string; drivingSchoolId: string }, "uid">;
